import { Injectable } from '@angular/core';
import { Api, User } from '../'

@Injectable()
export class Master {

  list:any;  
  constructor(public api:Api, public user:User) { 

  }

  getDetail(params?: any) {
      return this.api.get('index.php/advance/master/detail', params);
  }

  getEmployee(params?: any) {
      return this.api.get('index.php/advance/master/employee', params);
  }

  getOrganization(params?: any){
      if(this.user.data.business_level_id > 0){
          params.level_id = this.user.data.business_level_id;
      }
      return this.api.get('index.php/advance/master/organization', params);
  }

  getCompany(params?: any){
      return this.api.get('index.php/advance/master/company', params);
  }

  getDirektorat(params?: any){
    return this.api.get('index.php/advance/master/direktorat', params);
  }

  getDivisi(params?: any){
    return this.api.get('index.php/advance/master/divisi', params);
  }

  getBranch(params?: any){
    return this.api.get('index.php/advance/master/branch', params);
  }

  getRate(params?: any){
    return this.api.get('index.php/advance/master/rate', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/advance_providers/master/master.ts